import { select, takeLeading, put } from 'redux-saga/effects';
import { callApi, handleError, ResponseError } from 'helpers/saga-helpers';
import { isNil, isNull } from 'lodash';
import {
  REQUEST_CREATE_EXPERTISE_RAPORT,
  REQUEST_CREATE_JUDGEMENT_ADD,
  REQUEST_CREATE_JUDGEMENT_APPEAL,
  REQUEST_GET_JUDGEMENT_ADD,
  REQUEST_GET_EXPERTISE_RAPORT,
  REQUEST_CREATE_JUDGEMENT_ON_MERITS,
  REQUEST_GET_JUDGEMENT_ON_MERITS,
  REQUEST_GET_JUDGEMENT_APPEAL,
  REQUEST_GET_DAHIR_AMOUNT,
  REQUEST_GET_CIVIL_PROCEEDING,
  REQUEST_INSERT_DAHIR_AMOUNT_JOM,
  REQUEST_GET_DAHIR_AMOUNT_JOM_CORPO,
  REQUEST_CREATE_JUDGEMENT_ON_MERITS_CONTESTATION,
  REQUEST_UPDATE_CONTESTATION,
  REQUEST_UPLOAD_CONTESTATION_DOCUMENTS,
  REQUEST_GET_JUDGEMENT_ON_MERITS_APPEAL,
  REQUEST_GET_EXPERTISE_REPORT_APPEAL,
  REQUEST_GET_JUDGEMENT_ADD_APPEAL,
  REQUEST_CREATE_CIVIL_PROCEEDING,
  REQUEST_CREATE_MULTIPLE_JUDGEMENT_ADD,
  REQUEST_ADD_DOCUMENT_CLAIM,
  REQUEST_ADD_SUPPORT_DOCUMENT,
  REQUEST_CIVIL_PARTY_SUPPORT_DOCUMENT,
  REQUEST_ADD_EXPERT_REPORT_SUPPORT_DOCUMENT,
  REQUEST_ADD_JUDGEMENT_ON_MERITS_SUPPORT_DOCUMENT,
  REQUEST_UPDATE_JUDGEMENT_ADD,
  REQUEST_UPDATE_JUDGEMENT_ADD_DOCUMENT,
  REQUEST_UPDATE_LAWYER_FIRM_REFERENCE,
  REQUEST_GET_JUDGEMENT_ON_MERITS_MULTIPLE,
  REQUEST_GET_APPEAL_ON_MERITS_MULTIPLE,
  MODE as injuredMode,
  PROCEDURE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/constants';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import {
  setJudgementAdd,
  setExpertiseRaport,
  setJudgementOnMerits,
  setJudgementAppeal,
  setDahirAmount,
  setCivilProceeding,
  setDahirAmountCorpo,
  requestGetJudgementOnMerits,
  setJudgementOnMeritsAppeal,
  setExpertiseRaportAppeal,
  setJudgementAddAppeal,
  setJudgementOnMeritsMultiple,
  setAppealOnMeritsMultiple,
  resetJudgementAdd,
  resetExpertReport,
  resetJudgementOnMerits,
  resetMultipleJudgementOnMerits,
  requestGetJudgementAdd,
  requestGetCivilProceeding,
  requestGetJudgementOnMeritsMultiple,
  requestGetAppealOnMeritsMultiple,
} from 'containers/LawyerLegalProceedingsPage/actions';
import {
  IAppealPayload,
  ICreateMultipleJudgementAddDocAction,
  IFirmReferenceAction,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { get, without } from 'lodash';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import { Moment } from 'moment-timezone';
import { requestFeeNotesByClaimNumb } from 'containers/ManagerFeeNote/actions';
import { ICreateCivilProceedingAction } from 'containers/LawyerLegalProceedingsPage/typings';
import { requestClaimRecap } from 'containers/RecapManagerPage/actions';
import {
  startLoading,
  stopLoading,
} from 'containers/AppContainer/Loader/action';
import { requestGetPendingTasksClaim } from 'containers/CourtManagerLegalProceedings/actions';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { MODE } from 'containers/CourtManagerLegalProceedings/ExpertReport/constants';

export function* requestCreateJudgementAdd(action: {
  type: string;
  payload: {};
  callback: Function;
  handleError: Function;
}): Generator<unknown> {
  try {
    const { payload, callback, handleError: handleErrorValidation } = action;
    const token = !get(payload, 'isLawyer')
      ? accessTokenStorage.get().token
      : yield select(makeSelectKeycloakToken());
    if (!token && !get(payload, 'isLawyer')) return;
    const path = `/corporeal/judgement/add-judgement-add`;

    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };

    const errorResponse = yield callApi(path, {}, options, []);
    if (!errorResponse && callback) {
      if (!get(payload, 'judgementAdd.isLawyer')) {
        yield put(
          requestGetJudgementAdd(
            get(payload, 'judgementAdd.claimId'),
            get(payload, 'judgementAdd.procedureType'),
            get(payload, 'judgementAdd.judiciaryProcessId'),
          ),
        );
        featureService.hasFeature(FEATURES.EVOLUTION_P3)
          ? yield put(
              requestFeeNotesByClaimNumb(
                get(payload, 'judgementAdd.claimNumber'),
                [],
                true,
              ),
            )
          : yield put(
              requestFeeNotesByClaimNumb(
                get(payload, 'judgementAdd.claimNumber'),
              ),
            );
        yield put(
          requestGetPendingTasksClaim({
            claimNumber: get(payload, 'judgementAdd.claimNumber'),
            isImagineDocuments: true,
          }),
        );
      }
      yield callback();
    }
    if (errorResponse) {
      yield handleErrorValidation();
    }
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  }
}

export function* requestCreateJudgementAddSaga() {
  yield takeLeading(REQUEST_CREATE_JUDGEMENT_ADD, requestCreateJudgementAdd);
}

export function* getJudgementAdd(action: {
  type: string;
  claimId: number;
  procedureType: string;
  judiciaryProcessId: number;
}): Generator<unknown> {
  try {
    const { claimId, procedureType, judiciaryProcessId } = action;
    const token = get(accessTokenStorage.get(), 'token')
      ? get(accessTokenStorage.get(), 'token')
      : yield select(makeSelectKeycloakToken());
    const path =
      judiciaryProcessId === 0
        ? `/corporeal/judgement/get-judgement-add/${claimId}/${procedureType}`
        : `/corporeal/judgement/get-judgement-add/${claimId}/${procedureType}/${judiciaryProcessId}`;
    const formattedPath = get(accessTokenStorage.get(), 'token')
      ? path
      : path + '?isIntervenant=true';
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    yield put(resetJudgementAdd());
    yield put(startLoading(LOADERS.JUDGEMENT_ADD));
    yield callApi(formattedPath, {}, options, [], setJudgementAdd);
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  } finally {
    yield put(stopLoading(LOADERS.JUDGEMENT_ADD));
  }
}

export function* requestGetJudgementAddSaga() {
  yield takeLeading(REQUEST_GET_JUDGEMENT_ADD, getJudgementAdd);
}

export function* getJudgementAddAppeal(action: {
  type: string;
  claimId: number;
  procedureType: string;
  judiciaryProcessId: number;
}): Generator<unknown> {
  try {
    const { claimId, procedureType, judiciaryProcessId } = action;
    const token = get(accessTokenStorage.get(), 'token')
      ? get(accessTokenStorage.get(), 'token')
      : yield select(makeSelectKeycloakToken());
    const path =
      judiciaryProcessId === 0
        ? `/corporeal/judgement/get-judgement-add/${claimId}/${procedureType}`
        : `/corporeal/judgement/get-judgement-add/${claimId}/${procedureType}/${judiciaryProcessId}`;
    const formattedPath = get(accessTokenStorage.get(), 'token')
      ? path
      : path + '?isIntervenant=true';
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    yield put(startLoading(LOADERS.JUDGEMENT_ADD_APPEAL));
    yield callApi(formattedPath, {}, options, [], setJudgementAddAppeal);
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  } finally {
    yield put(stopLoading(LOADERS.JUDGEMENT_ADD_APPEAL));
  }
}

export function* requestGetJudgementAddAppealSaga() {
  yield takeLeading(REQUEST_GET_JUDGEMENT_ADD_APPEAL, getJudgementAddAppeal);
}

export function* requestCreateExpertiseRaport(action: {
  type: string;
  payload: { isLawyer: boolean };
  callback: Function;
  handleError: Function;
}): Generator<unknown> {
  const { payload, callback, handleError } = action;

  const token = !payload.isLawyer
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/judgement/add-expertise-reports-v2`;

  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };

  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield callback();

    if (!payload.isLawyer) {
      yield put(requestClaimRecap(get(payload, 'claimId')));
      yield put(
        requestGetPendingTasksClaim({
          claimNumber: get(payload, 'claimNumber'),
          isImagineDocuments: true,
        }),
      );
    }
  }
  if (errorResponse) {
    yield handleError();
  }
}

export function* requestCreateExpertiseRaportSaga() {
  yield takeLeading(
    REQUEST_CREATE_EXPERTISE_RAPORT,
    requestCreateExpertiseRaport,
  );
}

export function* requestCreateJudgementonMerits(action: {
  type: string;
  payload: { isLawyer: boolean };
  callback: Function;
}): Generator<unknown> {
  try {
    const { payload, callback } = action;
    const token = !payload.isLawyer
      ? accessTokenStorage.get().token
      : yield select(makeSelectKeycloakToken());
    if (!token) return;
    const path = `/corporeal/judgement/add-judgement-on-merits`;

    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };

    const errorResponse = yield callApi(path, {}, options, []);
    if (!errorResponse && callback) {
      if (!get(payload, 'isLawyer')) {
        yield put(
          requestGetJudgementOnMerits(
            get(payload, 'claimId'),
            get(payload, 'procedureType'),
            get(payload, 'judiciaryProcessId'),
          ),
        );
        yield put(
          get(payload, 'procedureType') === PROCEDURE_TYPES.APPEAL
            ? requestGetAppealOnMeritsMultiple(
                get(payload, 'claimId'),
                get(payload, 'procedureType'),
                get(payload, 'judiciaryProcessId'),
              )
            : requestGetJudgementOnMeritsMultiple(
                get(payload, 'claimId'),
                get(payload, 'procedureType'),
                get(payload, 'judiciaryProcessId'),
              ),
        );

        yield put(
          requestGetJudgementAdd(
            get(payload, 'claimId'),
            get(payload, 'procedureType'),
            get(payload, 'judiciaryProcessId'),
          ),
        );
        featureService.hasFeature(FEATURES.EVOLUTION_P3)
          ? yield put(
              requestFeeNotesByClaimNumb(get(payload, 'claimNumber'), [], true),
            )
          : yield put(requestFeeNotesByClaimNumb(get(payload, 'claimNumber')));
        yield put(
          requestGetPendingTasksClaim({
            claimNumber: get(payload, 'claimNumber'),
            isImagineDocuments: true,
          }),
        );
      }
      yield callback();
    }
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  }
}

export function* requestCreateJudgementonMeritsSaga() {
  yield takeLeading(
    REQUEST_CREATE_JUDGEMENT_ON_MERITS,
    requestCreateJudgementonMerits,
  );
}

export function* requestCreateJudgementonMeritsContestation(action: {
  type: string;
  payload: any;
  successCallback: Function;
}): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  if (!token) return;
  const path = `/corporeal/judgement-on-merits-contestation`;

  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };

  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield successCallback();
  }
}

export function* requestCreateJudgementonMeritsContestationSaga() {
  yield takeLeading(
    REQUEST_CREATE_JUDGEMENT_ON_MERITS_CONTESTATION,
    requestCreateJudgementonMeritsContestation,
  );
}

export function* getExpertiseRaport(action: {
  type: string;
  claimId: number;
  procedureType: string;
  judiciaryProcessId: number;
}): Generator<unknown> {
  try {
    const { claimId, procedureType, judiciaryProcessId } = action;
    const token = get(accessTokenStorage.get(), 'token')
      ? get(accessTokenStorage.get(), 'token')
      : yield select(makeSelectKeycloakToken());
    const path = `/corporeal/judgement/export-reports/${claimId}/${procedureType}/${judiciaryProcessId}`;
    const formattedPath = get(accessTokenStorage.get(), 'token')
      ? path
      : path + '?isIntervenant=true';
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    yield put(resetExpertReport());
    yield put(startLoading(LOADERS.EXPERT_REPORT));
    yield callApi(formattedPath, {}, options, [], setExpertiseRaport);
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  } finally {
    yield put(stopLoading(LOADERS.EXPERT_REPORT));
  }
}

export function* getExpertiseRaportSaga() {
  yield takeLeading(REQUEST_GET_EXPERTISE_RAPORT, getExpertiseRaport);
}

export function* getExpertiseRaportAppeal(action: {
  type: string;
  claimId: number;
  procedureType: string;
  judiciaryProcessId: number;
}): Generator<unknown> {
  try {
    const { claimId, procedureType, judiciaryProcessId } = action;
    const token = get(accessTokenStorage.get(), 'token')
      ? get(accessTokenStorage.get(), 'token')
      : yield select(makeSelectKeycloakToken());
    const path = `/corporeal/judgement/export-reports/${claimId}/${procedureType}/${judiciaryProcessId}`;
    const formattedPath = get(accessTokenStorage.get(), 'token')
      ? path
      : path + '?isIntervenant=true';
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    yield put(startLoading(LOADERS.EXPERT_REPORT_APPEAL));

    yield callApi(formattedPath, {}, options, [], setExpertiseRaportAppeal);
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  } finally {
    yield put(stopLoading(LOADERS.EXPERT_REPORT_APPEAL));
  }
}

export function* getExpertiseRaportAppealSaga() {
  yield takeLeading(
    REQUEST_GET_EXPERTISE_REPORT_APPEAL,
    getExpertiseRaportAppeal,
  );
}

export function* getJudgementOnMerits(action: {
  type: string;
  claimId: number;
  procedureType: string;
  judiciaryProcessId: number;
}): Generator<unknown> {
  try {
    const token = get(accessTokenStorage.get(), 'token')
      ? get(accessTokenStorage.get(), 'token')
      : yield select(makeSelectKeycloakToken());
    if (!token) return;
    const { claimId, procedureType, judiciaryProcessId } = action;
    const path =
      judiciaryProcessId === 0
        ? `/corporeal/judgement/judgement-on-merits/${claimId}/${procedureType}`
        : `/corporeal/judgement/judgement-on-merits/${claimId}/${procedureType}/${judiciaryProcessId}`;
    const formattedPath = get(accessTokenStorage.get(), 'token')
      ? path
      : path + '?isIntervenant=true';
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    yield put(resetJudgementOnMerits());
    yield put(startLoading(LOADERS.JUDGEMENT_ON_MERITS));
    yield callApi(formattedPath, {}, options, [], setJudgementOnMerits);
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  } finally {
    yield put(stopLoading(LOADERS.JUDGEMENT_ON_MERITS));
  }
}

export function* getJudgementOnMeritsAppeal(action: {
  type: string;
  claimId: number;
  procedureType: string;
  judiciaryProcessId: number;
}): Generator<unknown> {
  const { claimId, procedureType, judiciaryProcessId } = action;
  const token = get(accessTokenStorage.get(), 'token')
    ? get(accessTokenStorage.get(), 'token')
    : yield select(makeSelectKeycloakToken());
  const path =
    judiciaryProcessId === 0
      ? `/corporeal/judgement/judgement-on-merits/${claimId}/${procedureType}`
      : `/corporeal/judgement/judgement-on-merits/${claimId}/${procedureType}/${judiciaryProcessId}`;
  const formattedPath = get(accessTokenStorage.get(), 'token')
    ? path
    : path + '?isIntervenant=true';
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(formattedPath, {}, options, [], setJudgementOnMeritsAppeal);
}

export function* getJudgementOnMeritsSaga() {
  yield takeLeading(REQUEST_GET_JUDGEMENT_ON_MERITS, getJudgementOnMerits);
}

export function* getJudgementOnMeritsMultiple(action: {
  type: string;
  claimId: number;
  procedureType: string;
  judiciaryProcessId: number;
}): Generator<unknown> {
  try {
    const { claimId, procedureType, judiciaryProcessId } = action;
    const token = get(accessTokenStorage.get(), 'token')
      ? get(accessTokenStorage.get(), 'token')
      : yield select(makeSelectKeycloakToken());
    const path =
      judiciaryProcessId === 0
        ? `/corporeal/judgement/judgement-on-merits/v2?claimId=${claimId}&procedureType=${procedureType}`
        : `/corporeal/judgement/judgement-on-merits/v2?claimId=${claimId}&procedureType=${procedureType}&judiciaryProcessId=${judiciaryProcessId}`;
    const formattedPath = get(accessTokenStorage.get(), 'token')
      ? path
      : path + '&isIntervenant=true';
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    yield put(resetMultipleJudgementOnMerits());
    yield put(startLoading(LOADERS.MULTIPLE_JUDGEMENT_ON_MERITS));
    yield callApi(formattedPath, {}, options, [], setJudgementOnMeritsMultiple);
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  } finally {
    yield put(stopLoading(LOADERS.MULTIPLE_JUDGEMENT_ON_MERITS));
  }
}
export function* getJudgementOnMeritsMultipleSaga() {
  yield takeLeading(
    REQUEST_GET_JUDGEMENT_ON_MERITS_MULTIPLE,
    getJudgementOnMeritsMultiple,
  );
}

export function* getAppealOnMeritsMultipleSaga() {
  yield takeLeading(
    REQUEST_GET_APPEAL_ON_MERITS_MULTIPLE,
    getAppealOnMeritsMultiple,
  );
}
export function* getAppealOnMeritsMultiple(action: {
  type: string;
  claimId: number;
  procedureType: string;
  judiciaryProcessId: number;
}): Generator<unknown> {
  const { claimId, procedureType, judiciaryProcessId } = action;
  const token = get(accessTokenStorage.get(), 'token')
    ? get(accessTokenStorage.get(), 'token')
    : yield select(makeSelectKeycloakToken());
  const path =
    judiciaryProcessId === 0
      ? `/corporeal/judgement/judgement-on-merits/v2?claimId=${claimId}&procedureType=${procedureType}`
      : `/corporeal/judgement/judgement-on-merits/v2?claimId=${claimId}&procedureType=${procedureType}&judiciaryProcessId=${judiciaryProcessId}`;
  const formattedPath = get(accessTokenStorage.get(), 'token')
    ? path
    : path + '&isIntervenant=true';
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(formattedPath, {}, options, [], setAppealOnMeritsMultiple);
}

export function* getJudgementOnMeritsAppealSaga() {
  yield takeLeading(
    REQUEST_GET_JUDGEMENT_ON_MERITS_APPEAL,
    getJudgementOnMeritsAppeal,
  );
}
export function* requestCreateJudgementAppeal(action: {
  type: string;
  payload: IAppealPayload;
  callback: Function;
}): Generator<unknown> {
  const { payload, callback } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/judgement/add-appeal-judgement`;
  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };
  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield callback();
  }
}

export function* requestCreateJudgementAppealSaga() {
  yield takeLeading(
    REQUEST_CREATE_JUDGEMENT_APPEAL,
    requestCreateJudgementAppeal,
  );
}
export function* getJudgementAppeal(action: { type: string; claimId: number }) {
  const { claimId } = action;
  const path = `/corporeal/judgement/get-appeal-judgement/${claimId}`;

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  yield callApi(path, {}, options, [], setJudgementAppeal);
}
export function* getJudgementAppealSaga() {
  yield takeLeading(REQUEST_GET_JUDGEMENT_APPEAL, getJudgementAppeal);
}

export function* requestGetDahirAmount(action: {
  type: string;
  data: any;
}): Generator<unknown> {
  try {
    const { data } = action;
    const token = get(accessTokenStorage.get(), 'token')
      ? get(accessTokenStorage.get(), 'token')
      : yield select(makeSelectKeycloakToken());
    const fflipDahirV2 = featureService.hasFeature(
      FEATURES.GET_DAHIR_AMOUNT_V2,
    );
    const path = get(accessTokenStorage.get(), 'token')
      ? fflipDahirV2
        ? `/sagis/get-dahir-amount/v2`
        : `/sagis/get-dahir-amount`
      : fflipDahirV2
      ? `/sagis/get-dahir-amount/v2?isIntervenant=true`
      : `/sagis/get-dahir-amount?isIntervenant=true`;
    const injuredVictims = without(data['victimKeys'], null).reduce(
      (acc: any, value: any) => {
        acc[value] = MODE.BLESSE;
        return acc;
      },
      [],
    );
    const deceasedVictims = without(data['deceasedVictimKeys'], null).reduce(
      (acc: any, value: any) => {
        acc[value] = MODE.DECEASED;
        return acc;
      },
      [],
    );
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: fflipDahirV2
        ? JSON.stringify({ ...injuredVictims, ...deceasedVictims })
        : JSON.stringify({
            victimKeys: without(data['victimKeys'], null),
            deceasedVictimKeys: without(data['deceasedVictimKeys'], null),
            mode: injuredMode,
          }),
    };
    yield put(startLoading(LOADERS.DAHIR_AMOUNT));
    yield callApi(path, {}, options, [], setDahirAmount);
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  } finally {
    yield put(stopLoading(LOADERS.DAHIR_AMOUNT));
  }
}

export function* requestGetDahirAmountSaga() {
  yield takeLeading(REQUEST_GET_DAHIR_AMOUNT, requestGetDahirAmount);
}

export function* requestInsertDahirAmountJom(action: {
  type: string;
  payload: {};
}): Generator<unknown> {
  const { payload } = action;

  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/victim/amount`;
  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };

  yield callApi(path, {}, options, []);
}

export function* requestInsertDahirAmountJomSaga() {
  yield takeLeading(
    REQUEST_INSERT_DAHIR_AMOUNT_JOM,
    requestInsertDahirAmountJom,
  );
}

export function* requestGetDahirAmountJom(action: {
  type: string;
  claimId: number;
}): Generator<unknown> {
  try {
    const { claimId } = action;
    const token = get(accessTokenStorage.get(), 'token')
      ? get(accessTokenStorage.get(), 'token')
      : yield select(makeSelectKeycloakToken());
    const path = `/corporeal/victim/amount/${claimId}`;
    const formattedPath = get(accessTokenStorage.get(), 'token')
      ? path
      : path + '?isIntervenant=true';
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    yield put(startLoading(LOADERS.DAHIR_CORPO));

    yield callApi(formattedPath, {}, options, [], setDahirAmountCorpo);
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  } finally {
    yield put(stopLoading(LOADERS.DAHIR_CORPO));
  }
}

export function* requestGetDahirAmountJomSaga() {
  yield takeLeading(
    REQUEST_GET_DAHIR_AMOUNT_JOM_CORPO,
    requestGetDahirAmountJom,
  );
}
export function* getCivilProceeding(action: {
  type: string;
  claimId: number;
}): Generator<unknown> {
  const claimId = get(action, 'claimId', null);
  const token = get(accessTokenStorage.get(), 'token')
    ? get(accessTokenStorage.get(), 'token')
    : yield select(makeSelectKeycloakToken());
  if (isNull(token) || isNil(claimId)) return;
  const path = `/corporeal/judiciary-process/${claimId}`;
  const formattedPath = get(accessTokenStorage.get(), 'token')
    ? path
    : path + '?isIntervenant=true';
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(formattedPath, {}, options, [], setCivilProceeding);
}

export function* requestGetCivilProceedingSaga() {
  yield takeLeading(REQUEST_GET_CIVIL_PROCEEDING, getCivilProceeding);
}

export function* requestUpdateContestation(action: {
  type: string;
  id: any;
  audienceDate: Moment | null;
  lawyerOpinion: String | null;
  claimId: number;
  procedureType: string;
  judiciaryProcessId: number;
  validator: string;
  status: string;
  claimNumber: string;
  isLawyer: boolean;
  isModified: boolean;
  successCallback: Function;
  rejectionReason: string;
  globalContestationInfo?: any;
}): Generator<unknown> {
  const {
    id,
    audienceDate,
    claimId,
    procedureType,
    judiciaryProcessId,
    validator,
    status,
    claimNumber,
    lawyerOpinion,
    isLawyer,
    isModified,
    successCallback,
    rejectionReason,
    globalContestationInfo,
  } = action;

  const token = !isLawyer
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());

  if (!token) return;

  const path = `/corporeal/judgement-on-merits-contestation`;
  const options = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id,
      jomContestationInfo: {
        hearingDate: audienceDate,
        lawyerOpinion,
        status,
        rejectionReason,
        ...globalContestationInfo,
      },
      claimId,
      judiciaryProcessId,
      validator,
      status,
      claimNumber,
      isModified,
      isLawyer,
    }),
  };

  const errorResponse = yield callApi(path, {}, options, []);

  if (!errorResponse) {
    yield put(
      requestGetJudgementOnMerits(claimId, procedureType, judiciaryProcessId),
    );
    if (successCallback) yield successCallback();
  }
}

export function* requestUpdateContestationSaga() {
  yield takeLeading(REQUEST_UPDATE_CONTESTATION, requestUpdateContestation);
}

export function* requestUploadContestationDocument(action: {
  type: string;
  contestationDocuments: any;
  claimNumber: string;
  claimId: number;
  judiciaryProcessId: number;
  validator: string;
  contestationDocsToUpdate: any;
  procedureType: string;
  isLawyer: boolean;
  successCallback: Function;
  contestationNatureId: number;
  jmcId: number;
}): Generator<unknown> {
  const {
    contestationDocuments,
    claimNumber,
    claimId,
    judiciaryProcessId,
    validator,
    contestationDocsToUpdate,
    procedureType,
    isLawyer,
    successCallback,
    contestationNatureId,
    jmcId,
  } = action;

  const token = !isLawyer
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  if (!token) return;

  const path = `/corporeal/judgement-on-merits-contestation-document`;

  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      contestationDocuments,
      claimNumber,
      claimId,
      judiciaryProcessId,
      validator,
      contestationDocsToUpdate,
      contestationNatureId,
      jmcId,
      isLawyer,
    }),
  };

  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield put(
      requestGetJudgementOnMerits(claimId, procedureType, judiciaryProcessId),
    );
    if (successCallback) yield successCallback();
  }
}

export function* requestUploadContestationDocumentSaga() {
  yield takeLeading(
    REQUEST_UPLOAD_CONTESTATION_DOCUMENTS,
    requestUploadContestationDocument,
  );
}
export function* requestCreateCivilProceedingSaga() {
  yield takeLeading(
    REQUEST_CREATE_CIVIL_PROCEEDING,
    requestCreateCivilProceeding,
  );
}
export function* requestCreateCivilProceeding(
  action: ICreateCivilProceedingAction,
): Generator<unknown> {
  const { civilProceeding, successCallback } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/judiciary-process/add-judiciary-process`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...civilProceeding }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(requestGetCivilProceeding(get(civilProceeding, 'claimId')));
    yield put(requestClaimRecap(get(civilProceeding, 'claimId')));

    yield successCallback();
  }
}

export function* requestMultipleJudgementAdd(
  action: ICreateMultipleJudgementAddDocAction,
): Generator<unknown> {
  try {
    const { payload, callback } = action;

    const token = !get(payload, 'isLawyer')
      ? accessTokenStorage.get().token
      : yield select(makeSelectKeycloakToken());
    if (!token) return;
    const path = `/corporeal/judgement-add-document`;

    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };
    const errorResponse = yield callApi(path, {}, options, []);
    if (!errorResponse && callback) {
      if (!get(payload, 'isLawyer')) {
        yield put(
          requestGetJudgementAdd(
            get(payload, 'claimId'),
            get(payload, 'procedureType'),
            get(payload, 'judiciaryProcessId'),
          ),
        );
        yield put(
          requestGetPendingTasksClaim({
            claimNumber: get(payload, 'claimNumber'),
            isImagineDocuments: true,
          }),
        );
        featureService.hasFeature(FEATURES.EVOLUTION_P3)
          ? yield put(
              requestFeeNotesByClaimNumb(get(payload, 'claimNumber'), [], true),
            )
          : yield put(requestFeeNotesByClaimNumb(get(payload, 'claimNumber')));
      }
      yield callback();
    }
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  }
}

export function* requestCreateMultipleJudgementAddSaga() {
  yield takeLeading(
    REQUEST_CREATE_MULTIPLE_JUDGEMENT_ADD,
    requestMultipleJudgementAdd,
  );
}
export function* requestUpdateJudgementAdd(action: {
  type: string;
  payload: { isLawyer: boolean };
  callback: Function;
}): Generator<unknown> {
  const { payload, callback } = action;

  const token = !payload.isLawyer
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/judgement/change-judgement-add`;

  const options = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };
  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield callback();
  }
}

export function* requestUpdateJudgementAddSaga() {
  yield takeLeading(REQUEST_UPDATE_JUDGEMENT_ADD, requestUpdateJudgementAdd);
}

export function* requestUpdateJudgementAddDocument(action: {
  type: string;
  payload: {};
  callback: Function;
}): Generator<unknown> {
  const { payload, callback } = action;

  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/judgement-add-document/change-judgement-add-document`;

  const options = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };
  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield callback();
  }
}

export function* requestUpdateJudgementAddDocumentSaga() {
  yield takeLeading(
    REQUEST_UPDATE_JUDGEMENT_ADD_DOCUMENT,
    requestUpdateJudgementAddDocument,
  );
}

export function* requestAddDocument(action: {
  type: string;
  payload: { name: string; url: string; type: string; claimId: number };
  callback: Function;
}): Generator<unknown> {
  const { payload, callback } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/document`;

  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };

  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield callback();
  }
}

export function* requestAddDocumentSaga() {
  yield takeLeading(REQUEST_ADD_DOCUMENT_CLAIM, requestAddDocument);
}

export function* requestAddSupportDocument(action: {
  type: string;
  payload: {
    name: string;
    url: string;
    type: string;
    judgementAddId: number;
    isLawyer: boolean;
  };
  callback: Function;
}): Generator<unknown> {
  const { payload, callback } = action;
  const token = !payload.isLawyer
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/support-document`;

  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };

  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield callback();
    yield put(
      requestGetPendingTasksClaim({
        claimNumber: get(payload, 'claimNumber'),
        isImagineDocuments: true,
      }),
    );
  }
}

export function* requestCivilPartySupportDocumentSaga() {
  yield takeLeading(
    REQUEST_CIVIL_PARTY_SUPPORT_DOCUMENT,
    requestAddSupportDocument,
  );
}

export function* requestAddSupportDocumentSaga() {
  yield takeLeading(REQUEST_ADD_SUPPORT_DOCUMENT, requestAddSupportDocument);
}

export function* requestExpertReportSupportDocumentSaga() {
  yield takeLeading(
    REQUEST_ADD_EXPERT_REPORT_SUPPORT_DOCUMENT,
    requestAddSupportDocument,
  );
}

export function* requestJudgementOnMeritsSupportDocumentSaga() {
  yield takeLeading(
    REQUEST_ADD_JUDGEMENT_ON_MERITS_SUPPORT_DOCUMENT,
    requestAddSupportDocument,
  );
}

export function* updateLawyerFirmReference(
  action: IFirmReferenceAction,
): Generator<unknown> {
  const { payload, callback } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/assignment/change-firm-reference`;

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(requestClaimRecap(payload.claimId));
    yield callback();
  }
}

export function* updateLawyerFirmReferenceSaga() {
  yield takeLeading(
    REQUEST_UPDATE_LAWYER_FIRM_REFERENCE,
    updateLawyerFirmReference,
  );
}

export default [
  requestCreateJudgementAddSaga,
  requestGetJudgementAddSaga,
  requestCreateExpertiseRaportSaga,
  getExpertiseRaportSaga,
  requestCreateJudgementonMeritsSaga,
  getJudgementOnMeritsSaga,
  requestCreateJudgementAppealSaga,
  getJudgementAppealSaga,
  requestGetDahirAmountSaga,
  requestGetCivilProceedingSaga,
  getCivilProceeding,
  requestGetDahirAmountJomSaga,
  requestInsertDahirAmountJomSaga,
  requestCreateJudgementonMeritsContestationSaga,
  requestUpdateContestationSaga,
  requestUploadContestationDocumentSaga,
  getJudgementOnMeritsAppealSaga,
  getExpertiseRaportAppealSaga,
  requestGetJudgementAddAppealSaga,
  requestCreateCivilProceedingSaga,
  requestCreateMultipleJudgementAddSaga,
  requestAddDocumentSaga,
  requestAddSupportDocumentSaga,
  requestCivilPartySupportDocumentSaga,
  requestExpertReportSupportDocumentSaga,
  requestJudgementOnMeritsSupportDocumentSaga,
  requestUpdateJudgementAddSaga,
  requestUpdateJudgementAddDocumentSaga,
  updateLawyerFirmReferenceSaga,
  getJudgementOnMeritsMultipleSaga,
  getAppealOnMeritsMultipleSaga,
];
